export const getUserInfo = (state) => state.user.userInfo;
export const getUserEmail = (state) => state.user.userInfo?.email;
export const getGeniusLevel = (state) => state.user.userInfo?.geniusLevel;
export const getUserSlice = (state) => state.user;
export const getUserTravellers = (state) => state.user.travellers;
